module.exports = __webpack_public_path__ + "img/div5.baef8a13.jpg";